import React from "react";
import {Box} from "@mui/material";
import {CustomDatePicker} from "../../../../../components/CustomDatePicker";
import {CustomSelectMultiple} from "../../../../../components/CustomSelectMultiple";

/**
 * Contract of a guard: its dates and the zone accesses it is assigned to. Read-only when disabled.
 */
const GuardContractStep = ({
                               employeeData,
                               onChange,
                               emptyFields,
                               isValidEndDate,
                               setIsValidEndDate,
                               zoneAccesses,
                               zoneAccessIds,
                               setZoneAccessIds,
                               disabled = false,
                           }) => (
    <div className={'row mt-3'}>
        <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <CustomDatePicker
                id={"dp_gcs_start_date"}
                name={'startDate'}
                disabled={disabled}
                onChange={(e) => onChange({target: {value: e, name: 'startDate'}})}
                trans={"start_date"}
                value={employeeData.startDate}
                required={true}
                emptyFields={emptyFields}
                disableFuture={false}
                openTo={"day"}
            />
        </Box>
        <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <CustomDatePicker
                id={"dp_gcs_end_date"}
                name={'endDate'}
                disabled={disabled || employeeData.startDate === null}
                onChange={(e) => onChange({target: {value: e, name: 'endDate'}})}
                trans={"end_date"}
                value={employeeData.endDate}
                required={false}
                disableFuture={false}
                openTo={"day"}
                helperText={"please_leave_this_field_empty_if_the_contract_duration_is_indefinite"}
                minDate={employeeData.startDate}
                isValid={isValidEndDate}
                onError={(error) => setIsValidEndDate(error === null)}
            />
        </Box>
        <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <CustomSelectMultiple
                id={"slt_gcs_zone_access"}
                disabled={disabled}
                name={"zoneAccessIds"}
                value={zoneAccessIds}
                keyName="id"
                onChange={(e) => setZoneAccessIds(e.target.value)}
                list={zoneAccesses}
                trans={"zone_access"}
                required={false}
            />
        </Box>
    </div>
);

export default GuardContractStep;
